import React from 'react';

import { IIconProps, TIconType } from '../interface';

const IncreaseIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='5'
			viewBox='0 0 10 5'
			width='10'
		>
			<path
				d='M9.89892 4.45235L5.24231 0.0939612C5.10846 -0.0313197 4.89144 -0.0313196 4.75759 0.0939612L0.101096 4.45235C-0.114839 4.65445 0.0380287 5 0.343491 5L9.65656 5C9.96192 5 10.1148 4.65444 9.89892 4.45235Z'
				fill={props?.color || '#2E2E6B'}
			/>
		</svg>
	);
};

export default IncreaseIcon;
